import { OrcaLooping } from "../../components/src/video/orca/OrcaLooping";
import { firstLineExecution } from "./firstLineExecution";

firstLineExecution();
export default OrcaLooping;
